import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { GtmTrackingService } from 'src/app/services/gtm-tracking.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OneTrustService {

  constructor(
     private readonly gtm: GtmTrackingService,
    private readonly cookie: CookieService,
  ) { }
  isGaScriptadded!: boolean 
  isOnetrustscriptadded!: boolean 


  getCookieValue(key: string): string {
    const cookies = document.cookie.split('; ');
    const cookieName = `${key}=`;
    for (const cookie of cookies) {
      if (cookie.startsWith(cookieName)) {
        return cookie.substring(cookieName?.length);
      }
    }
    return '';
  }

   denyGrantGATag(): void {
    const existingConsent = this.getCookieValue('OptanonConsent') || null;
    let existingConsentArray = existingConsent ? existingConsent.split('&groups=') : [];
    if (existingConsentArray?.length) {
      existingConsentArray =  decodeURIComponent(existingConsentArray[1]).split(',')
    }
    const consentGroups = { 
      'C0004:0': ['ad_storage', 'ad_user_data', 'ad_personalization'],
      'C0003:0': ['analytics_storage'],
      'C0002:0': ['functionality_storage'],
      'C0001:0': ['personalization_storage', 'security_storage']
    };
    const consentStatus = Object.entries(consentGroups).reduce((acc: { [key: string]: string}, [group, purposes]) => {
      const isGranted = !existingConsentArray.includes(group);
      purposes.forEach(purpose => acc[purpose] = isGranted ? 'granted' : 'denied');
      return acc;
    }, {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push('consent', 'default', {
      ...consentStatus,
      wait_for_update: 500
    });
    const scriptUrl = 'https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js';
    const scriptType = 'text/javascript';
    const charset = 'UTF-8';
    if (!this.isOnetrustscriptadded) {
      this.addexternalScript(scriptUrl, scriptType, charset, environment.onetrustCookieId);
    }
  }

  addexternalScript(scriptUrl: string, type: string, charset: string, dataDomainScript: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.setAttribute('type', type);
      script.setAttribute('charset', charset);
      script.setAttribute('data-domain-script', dataDomainScript);
      document.head.appendChild(script);
      this.isOnetrustscriptadded = true
    });
  }


}
